/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrInput from "@grapecity/wijmo.react.input"

import { faFileImport, faFileInvoiceDollar, faSearch, faTruck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { createContext, useCallback, useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row, Table } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import DateInput from "../../../components/InputWrapper/DateInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import { RootState } from "../../../globalStore/rootreducer"
import { TWijmoComboBox } from "../../../type/wijmoComponents"

import { Form } from "react-bootstrap"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"

import { useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import { clearAlert, setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import {
  TKaikonZyutyuHaisyaGetRes,
  TKaikonZyutyuHaisyaKoteiGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"

import _ from "lodash"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T支払先 } from "../../../components/ComboBox/SiharaiSakiComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import RequiredMark from "../../../components/RequiredMark"
import NinusiSeikyuSearchModal from "../../../components/SearchModal/NinusiSeikyuSearchModal"
import CONSTANT from "../../../constant"
import { 区分分類コード } from "../../../constant/enum/codes"
import { e計上基準日区分, T計上基準日区分 } from "../../../constant/enum/master"
import {
  e工程区分,
  e工程区分名称,
  e海コン付帯作業区分,
  e税込区分,
  e課税区分,
  e請求支払区分,
  e配車状態区分,
  T工程区分値,
} from "../../../constant/enum/zyutuHaisya"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import { TNinusiInfoGetRes } from "../../../service/master/ninusi/TNinusi"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import { TEtc紐づけ情報, TZyutyuHaisyaETCKosokuryoPostRes } from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import ZyutyuHaisyaService from "../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import KaikonZyutyuHaisyaService from "../../../service/orderContainer/kaikonZyutyuHaisya/kaikonZyutyuHaisyaService"
import KaikonZyutyuHaisyaPatternService from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/kaikonZyutyuHaisyaPatternService"
import { TKaikonZyutyuHaisyaPatternListGetRes } from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/TKaikonZyutyuHaisyaPattern"
import { TApiResponse } from "../../../service/TApiResponse"
import commonUtil from "../../../ts/util/commonUtil"
import { is請求確認済 as is請求確認済Inner } from "../../../ts/util/haisyaUtil"
import { createコース編集 as createコース編集Inner } from "../KaikonZyutyuHaisyaList/KaikonZyutuHaisyaListGridUtil"
import KaikonZyutyuHaisyaPatternModal from "../KaikonZyutyuHaisyaList/KaikonZyutyuHaisyaPatternModal/KaikonZyutyuHaisyaPatternModal"
import SagyoGridRow from "./SagyoGridRow"

export type T作業情報Grid = Partial<TKaikonZyutyuHaisyaKoteiGetRes> & {
  傭車会社ID?: number
  傭車会社コード?: string
}

export type T請求支払情報Grid = {
  種別: string
  運送料課税区分コード?: string
  運送料金額: number
  付帯料課税区分コード?: string
  付帯料金額: number
  高速料金税込区分コード?: string
  高速料金額: number
  備考: string
}

export const EtcDataContext = createContext<TZyutyuHaisyaETCKosokuryoPostRes>([])

/**
 * 海コン受注配車入力
 * @returns
 */
const KaikonZyutyuHaisyaRegister = () => {
  const history = useHistory()
  // const location = useLocation()
  const { id } = useParams<{ id: string }>()
  const dispatch: AppDispatch = useDispatch()
  // ログインユーザ情報
  const { LoginUserInfo: userInfo } = useSelector((state: RootState) => state.user)
  const createInit作業情報 = (工程区分: T工程区分値): TKaikonZyutyuHaisyaKoteiGetRes => ({
    受注配車工程ID: undefined,
    工程区分コード: 工程区分.toString(),
    工程区分名称1: e工程区分名称[工程区分].toString(),
  })

  const [initPICK情報, setInitPICK情報] = useState<TKaikonZyutyuHaisyaKoteiGetRes | undefined>(
    createInit作業情報(e工程区分.PICK),
  )
  const [init作業情報, setInit作業情報] = useState<TKaikonZyutyuHaisyaKoteiGetRes | undefined>(
    createInit作業情報(e工程区分.作業),
  )
  const [init返却情報, setInit返却情報] = useState<TKaikonZyutyuHaisyaKoteiGetRes | undefined>(
    createInit作業情報(e工程区分.返却),
  )
  const [initその他情報, setInitその他情報] = useState<TKaikonZyutyuHaisyaKoteiGetRes | undefined>(
    createInit作業情報(e工程区分.その他),
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //TODO:ページ名称確定必須
  // let gridId = "KaikonZyutyuHaisyaRegister_GridId"

  //#region [createCollectionView]

  /**
   * 請求支払情報のcollectionView作成
   * @param data
   * @returns
   */
  const create請求支払CollectionView = (data?: TKaikonZyutyuHaisyaGetRes) => {
    const 請求情報: T請求支払情報Grid = {
      種別: "請求",
      運送料課税区分コード: data?.請求運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.請求運送料 ?? 0,
      付帯料課税区分コード: data?.請求付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.請求付帯料 ?? 0,
      高速料金税込区分コード: data?.請求高速料税込区分コード ?? e税込区分.税込,
      高速料金額: data?.請求高速料 ?? 0,
      備考: data?.請求備考 ?? "",
    }

    const 支払情報: T請求支払情報Grid = {
      種別: "支払",
      運送料課税区分コード: data?.請求運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.支払運送料 ?? 0,
      付帯料課税区分コード: data?.請求付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.支払付帯料 ?? 0,
      高速料金税込区分コード: data?.請求高速料税込区分コード ?? e税込区分.税込,
      高速料金額: data?.支払高速料 ?? 0,
      備考: data?.支払備考 ?? "",
    }
    return new wjCore.CollectionView<T請求支払情報Grid>([請求情報, 支払情報])
  }
  const setPattern請求支払CollectionView = (data?: TKaikonZyutyuHaisyaPatternListGetRes) => {
    const 請求情報: T請求支払情報Grid = {
      種別: "請求",
      運送料課税区分コード: data?.請求運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.請求運送料 ?? 0,
      付帯料課税区分コード: data?.請求付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.請求付帯料 ?? 0,
      高速料金税込区分コード: data?.請求高速料税込区分コード ?? e税込区分.税込,
      高速料金額: data?.請求高速料 ?? 0,
      備考: data?.請求備考 ?? "",
    }

    const 支払情報: T請求支払情報Grid = {
      種別: "支払",
      運送料課税区分コード: data?.請求運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.支払運送料 ?? 0,
      付帯料課税区分コード: data?.請求付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.支払付帯料 ?? 0,
      高速料金税込区分コード: data?.請求高速料税込区分コード ?? e税込区分.税込,
      高速料金額: data?.支払高速料 ?? 0,
      備考: data?.支払備考 ?? "",
    }
    return new wjCore.CollectionView<T請求支払情報Grid>([請求情報, 支払情報])
  }

  //#endregion
  //#region [state]

  const [支払先ItemSource, set支払先ItemSource] = useState<T支払先[]>()
  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [作業区分ItemSource, set作業区分ItemSource] = useState<T区分マスタ[]>()

  const [searchResult, setSearchResult] = useState<TKaikonZyutyuHaisyaGetRes>()

  const [荷主コード, set荷主コード] = useState<string>()
  const 荷主コードRef = useRef<string>()
  const [荷主略称1, set荷主略称1] = useState<string>()
  const [荷主請求ID, set荷主請求ID] = useState<number | null>()
  const [荷主請求ItemSource, set荷主請求ItemSource] = useState<T表紙分割[]>()
  const 荷主請求Ref = useRef<number | null>()
  const [荷主依頼番号, set荷主依頼番号] = useState<string>()
  const [受注部所コード, set受注部所コード] = useState<T部所マスタ["部所コード"] | null>(null)
  const 受注部所コードRef = useRef<T部所マスタ["部所コード"]>()
  const [select受注部所, setSelect受注部所] = useState<T部所マスタ>()

  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [受注パターンコード, set受注パターンコード] = useState<string>()
  const [請求区分コード, set請求区分コード] = useState<string | null>()
  const [配車状態区分コード, set配車状態区分コード] = useState<string | null>()
  const [コンテナNO, setコンテナno] = useState<string>()
  const [船社, set船社] = useState<string>()
  const [BLBK, setBLBK] = useState<string>()
  const [本船名, set本船名] = useState<string>()
  const [VOY, setVOY] = useState<string>()

  const [コンテナサイズ区分コード, setコンテナサイズ区分コード] = useState<string | null>()
  const [コンテナ軸区分コード, setコンテナ軸区分コード] = useState<string | null>()

  const [オーダー内容, setオーダー内容] = useState<string>()
  const [オーダー備考, setオーダー備考] = useState<string>()
  const [オーダー指定時間, setオーダー指定時間] = useState<string>()
  const [PICK情報, setPICK情報] = useState<T作業情報Grid>()
  const [作業情報, set作業情報] = useState<T作業情報Grid>()
  const [返却情報, set返却情報] = useState<T作業情報Grid>()
  const [その他情報, setその他情報] = useState<T作業情報Grid>()
  const [荷主ItemSource, set荷主ItemSource] = useState<TNinusiInfoGetRes[]>()
  const [請求計上日, set請求計上日] = useState<string | null | undefined>()
  const [更新日時, set更新日時] = useState<string>()
  const [計上基準日区分コード, set計上基準日区分コード] = useState<string>()
  const [計上基準日区分名称, set計上基準日区分名称] = useState<string>()
  const [請求内訳id, set請求内訳id] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()
  const [請求車番, set請求車番] = useState<string>()
  const [請求額確認区分名称1, set請求額確認区分名称1] = useState<string>()
  const [請求額確認区分コード, set請求額確認区分コード] = useState<string>()
  const [請求処理状態区分コード, set請求処理状態区分コード] = useState<string>()
  const [傭車会社コード, set傭車会社コード] = useState<string>()

  const [ETC情報, setETC情報] = useState<TEtc紐づけ情報[]>([])
  const [請求支払情報, set請求支払情報] = useState<{
    data: wjCore.CollectionView<T請求支払情報Grid>
  }>({ data: create請求支払CollectionView() })

  const [コース編集, setコース編集] = useState<string>()
  const [受領書有無フラグ, set受領書有無フラグ] = useState<number>(0)
  const [受領書確認フラグ, set受領書確認フラグ] = useState<number>(0)

  const [課税区分DataMap, set課税区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [税込区分DataMap, set税込区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [付帯作業分類区分List, set付帯作業分類区分List] = useState<T区分マスタ[]>([])
  const [請求flexGrid, set請求FlexGrid] = useState<wjcGrid.FlexGrid>()
  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  // パターン検索
  const [is海コン受注配車パターン検索Modal, setIs海コン受注配車パターン検索Modal] = useState(false)
  const [モーダル検索用荷主コード, setモーダル検索用荷主コード] = useState<string | undefined>()
  const [モーダル検索用荷主名, setモーダル検索用荷主名] = useState<string | undefined>()
  // 登録確認モーダル
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // 削除確認モーダル
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] = useState(false)

  //#endregion

  //#region [comboboxState]

  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<T表紙分割["荷主請求ID"], T表紙分割> | null>(
    null,
  )
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)

  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)

  // 請求区分
  const [請求区分ComboBox, set請求区分ComboBox] = useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [請求区分isLoadEnded, set請求区分isLoadEnded] = useState<boolean>(false)

  // 配車状態区分
  const [配車状態区分ComboBox, set配車状態区分ComboBox] = useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [配車状態区分isLoadEnded, set配車状態区分isLoadEnded] = useState<boolean>(false)

  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<string, T部所マスタ> | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  // コンテナサイズ
  const [コンテナサイズComboBox, setコンテナサイズComboBox] = useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [コンテナサイズIsLoadEnded, setコンテナサイズIsLoadEnded] = useState<boolean>(false)

  // コンテナ軸
  const [コンテナ軸ComboBox, setコンテナ軸ComboBox] = useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [コンテナ軸IsLoadEnded, setコンテナ軸IsLoadEnded] = useState<boolean>(false)

  // 受領書有無
  const [受領書有無ComboBox, set受領書有無ComboBox] = useState<TWijmoComboBox<
    string,
    { name: string; value: number }
  > | null>(null)
  const [受領書有無IsLoadEnded, set受領書有無IsLoadEnded] = useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [請求支払GridInitialized, set請求支払GridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  // 画面初期化フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)
  const [pageInitialized, setPageInitialized] = useState(false)

  //登録時画面遷移判定用
  const [isPageMove, setIsPageMove] = useState<boolean>(false)
  //#endregion

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new SiharaisakiService().getList({}),
    ]).then(([部所ListRes, 区分マスタRes, 支払先マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
      区分マスタRes && set作業区分ItemSource(区分マスタRes.data.filter((d) => d.区分コード.match(new RegExp(/2./))))
      set部所ItemSource(部所ListRes.data)
      if (!荷主ItemSource) {
        get荷主itemSource()
      }
      set支払先ItemSource(支払先マスタRes.data)
      set課税区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分),
          "区分コード",
          "名称1",
        ),
      )
      set税込区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.受注配車_請求支払.税込区分),
          "区分コード",
          "名称1",
        ),
      )
      set付帯作業分類区分List(
        区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.受注配車_請求支払.海コン付帯作業区分),
      )
      if (!id) {
        createInit作業情報(e工程区分.PICK)
      }
      setComboDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    if (
      comboDataInitialized &&
      請求支払GridInitialized &&
      表紙分割ComboBox &&
      請求内訳ComboBox &&
      配車状態区分ComboBox &&
      受注部所ComboBox &&
      請求区分ComboBox &&
      受領書有無ComboBox
    ) {
      setPageInitialized(true)
    }
  }, [
    comboDataInitialized,
    請求支払GridInitialized,
    表紙分割ComboBox,
    請求内訳ComboBox,
    配車状態区分ComboBox,
    受注部所ComboBox,
    請求区分ComboBox,
    受領書有無ComboBox,
  ])

  //useEffect内ではasyncが使用できないため外部に記述
  const 荷主取得 = async (荷主コード?: string) => {
    if (荷主コード == null || wjCore.isNullOrWhiteSpace(荷主コード ?? "")) {
      set荷主略称1("")
      set荷主請求ItemSource([])
      set請求内訳ItemSource([])
      return
    }
    try {
      const 荷主res = await new NinusiService().getList({
        荷主コード,
        完全一致フラグ: true,
      })

      if (荷主res != null && 荷主res.data.length > 0) {
        const 荷主 = 荷主res.data[0]
        set荷主略称1(荷主.荷主略称1)
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: 荷主.荷主ID,
          削除済み包含フラグ: true,
        })
        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([..._.orderBy(荷主請求res.data, ["荷主コード", "表紙分割コード"])])
          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([..._.orderBy(請求内訳Res.data, ["請求内訳コード"])])
          } else {
            set請求内訳ItemSource([])
          }
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set荷主略称1("")
        set荷主請求ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
      set荷主略称1("")
      set荷主請求ItemSource([])
      set請求内訳ItemSource([])
    }
  }

  //  荷主請求idの切り替えに合わせて請求内訳の表示データを変更
  useEffect(() => {
    if (請求内訳ComboBox != null) {
      請求内訳ComboBox.collectionView.filter = (item) => {
        return item.荷主請求ID === 荷主請求ID || item.荷主請求内訳ID === 0
      }
      請求内訳ComboBox.isDisabled = ![...請求内訳ComboBox.collectionView.items].find((item) => {
        return item.荷主請求ID === 荷主請求ID
      })
      請求内訳ComboBox.collectionView.refresh()
      請求内訳ComboBox.refresh()
    }
  }, [荷主コード, 荷主請求ID])

  useEffect(() => {
    // 変更した荷主請求IDより請求高速料等をセットしなおし
    if (請求flexGrid && 荷主請求ItemSource) {
      const 荷主請求Data = 荷主請求ItemSource.find((i) => i.荷主請求ID === 荷主請求ID)
      if (!荷主請求Data) return

      // 型定義付与のため変数に格納
      const 請求items: T請求支払情報Grid[] = 請求flexGrid.collectionView.sourceCollection
      if (!請求items) return
      請求items.forEach((i) => {
        i.高速料金税込区分コード = 荷主請求Data.高速料税込区分コード
      })
      請求flexGrid.refresh()
    }
  }, [荷主請求ID, 請求flexGrid, 荷主請求ItemSource])

  useEffect(() => {
    //初回検索中は自動での値変更を行わないようにする
    !isRestoreSearching && createコース編集()

    const input請求車番 =
      作業情報?.車番 != null && 作業情報?.車番 !== ""
        ? 作業情報?.車番
        : PICK情報?.車番 != null && PICK情報?.車番 !== ""
          ? PICK情報?.車番
          : 返却情報?.車番 != null && 返却情報?.車番 !== ""
            ? 返却情報?.車番
            : その他情報?.車番 != null && その他情報?.車番 !== ""
              ? その他情報?.車番
              : 請求車番 != null && 請求車番 !== ""
                ? 請求車番
                : undefined

    set請求車番(input請求車番)
    if (請求flexGrid) {
      const 請求GridData: T請求支払情報Grid[] = 請求flexGrid.collectionView.sourceCollection
      請求GridData[0].付帯料金額 =
        (PICK情報?.海コン付帯作業手当 ?? 0) +
        (作業情報?.海コン付帯作業手当 ?? 0) +
        (返却情報?.海コン付帯作業手当 ?? 0) +
        (その他情報?.海コン付帯作業手当 ?? 0)

      請求GridData[0].高速料金額 =
        (PICK情報?.海コン付帯高速料 ?? 0) +
        (作業情報?.海コン付帯高速料 ?? 0) +
        (返却情報?.海コン付帯高速料 ?? 0) +
        (その他情報?.海コン付帯高速料 ?? 0)

      if (!請求GridData[0].備考) {
        const 付帯作業区分コード =
          PICK情報?.海コン付帯作業区分コード ??
          作業情報?.海コン付帯作業区分コード ??
          返却情報?.海コン付帯作業区分コード ??
          その他情報?.海コン付帯作業区分コード ??
          null
        if (付帯作業区分コード && 付帯作業区分コード !== e海コン付帯作業区分.フォーク作業) {
          請求GridData[0].備考 = 付帯作業分類区分List.filter((d) => d.区分コード === 付帯作業区分コード)[0].名称1
        }
      }
      請求flexGrid.refresh()
    }
  }, [PICK情報, 作業情報, 返却情報, その他情報])

  useEffect(() => {
    // どれかに傭車会社が入っていた場合にそれを利用する
    let inner傭車会社コード
    if (PICK情報?.傭車会社コード) {
      inner傭車会社コード = PICK情報?.傭車会社コード
    } else if (作業情報?.傭車会社コード) {
      inner傭車会社コード = 作業情報?.傭車会社コード
    } else if (返却情報?.傭車会社コード) {
      inner傭車会社コード = 返却情報?.傭車会社コード
    } else if (その他情報?.傭車会社コード) {
      inner傭車会社コード = その他情報?.傭車会社コード
    }

    set傭車会社コード(inner傭車会社コード)
  }, [PICK情報?.傭車会社コード, 作業情報?.傭車会社コード, 返却情報?.傭車会社コード, その他情報?.傭車会社コード])

  const change請求計上日 = useCallback(
    (計上基準日区分: T計上基準日区分, 対象積卸日: string | undefined) => {
      if (請求内訳id != null) {
        //初回検索中は自動での値変更を行わないようにする
        if (isRestoreSearching) return
        const 請求内訳 = 請求内訳ItemSource?.find((i) => i.荷主請求内訳ID === 請求内訳id)
        if (請求内訳 == null) return
        if (計上基準日区分 === 請求内訳.計上基準日区分コード) {
          set請求計上日(対象積卸日)
        }
      }
    },
    [請求内訳id, 請求内訳ItemSource, isRestoreSearching],
  )

  //請求計上日のみ特別処理
  //各作業日（積卸日）が更新されたタイミングで荷主請求内訳を確認し、そちらに入っている物で請求計上日を更新する。
  useEffect(() => {
    change請求計上日(e計上基準日区分.PICK日, PICK情報?.積卸日)
  }, [PICK情報?.積卸日])

  useEffect(() => {
    change請求計上日(e計上基準日区分.作業日, 作業情報?.積卸日)
  }, [作業情報?.積卸日])

  useEffect(() => {
    change請求計上日(e計上基準日区分.返却日, 返却情報?.積卸日)
  }, [返却情報?.積卸日])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (pageInitialized) {
      //初回filter作成時にidがいた場合、検索を行う
      if (id != null && id !== "") {
        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(id)
          .then((res) => {
            if (res && res.data) {
              setData(res.data)
              荷主請求Ref.current = res.data.荷主請求ID
            }
          })
          .finally(() => {
            setIsRestoreSearching(false)
            dispatch(画面ロック解除())
            請求flexGrid?.refresh()
          })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
        setIsRestoreSearching(false)
        // 初期値をログインユーザの部所コードとする
        set受注部所コード(userInfo.部所コード)
      }
    }
  }, [pageInitialized])

  //請求内訳の変更に合わせて計上基準日も変更する
  useEffect(() => {
    if (請求内訳id) {
      const 請求内訳 = 請求内訳ItemSource?.find((i) => i.荷主請求内訳ID === 請求内訳id)
      if (請求内訳) {
        //初回検索中は自動での値変更を行わないようにする
        if (isRestoreSearching) return
        set計上基準日区分名称(請求内訳.計上基準日区分名称1)
        set計上基準日区分コード(請求内訳.計上基準日区分コード)
        if (請求計上日 == null || 請求計上日 === "") {
          switch (請求内訳.計上基準日区分コード) {
            case e計上基準日区分.PICK日:
              set請求計上日(PICK情報?.積卸日)
              break
            case e計上基準日区分.作業日:
              set請求計上日(作業情報?.積卸日)
              break
            case e計上基準日区分.返却日:
              set請求計上日(返却情報?.積卸日)
              break
          }
        }
      } else {
        set計上基準日区分名称("")
        set計上基準日区分コード("")
      }
    } else {
      set計上基準日区分名称("")
      set計上基準日区分コード("")
    }
  }, [請求内訳id, 請求内訳ItemSource])

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    請求flexGrid?.formatItem.removeAllHandlers()
    請求flexGrid?.formatItem.addHandler(請求formatItemHandler)
    請求flexGrid?.beginningEdit.removeAllHandlers()
    請求flexGrid?.beginningEdit.addHandler(請求beginningEditHandler)
  }, [請求額確認区分コード, 請求処理状態区分コード])

  //#endregion

  //#region [method]

  /**
   * 検索
   */
  const search = async (id: string) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const service = new KaikonZyutyuHaisyaService()

      const res = await service.get(id)
      setSearchResult(res.data)
      if (res.data) {
        // ETC情報を取得
        const ETCRes = await new ZyutyuHaisyaService().getEtcKosokuryo({
          受注配車IdList: [id],
        })
        if (ETCRes && ETCRes.data && ETCRes.data.length > 0) {
          setETC情報([...ETCRes.data])
        }
        setData(res.data)

        setPICK情報(res.data.PICK受注配車工程 ?? createInit作業情報(e工程区分.PICK))
        set作業情報(res.data.作業受注配車工程 ?? createInit作業情報(e工程区分.作業))
        set返却情報(res.data.返却受注配車工程 ?? createInit作業情報(e工程区分.返却))
        setその他情報(res.data.その他受注配車工程 ?? createInit作業情報(e工程区分.その他))
        setInitPICK情報(res.data.PICK受注配車工程 ?? createInit作業情報(e工程区分.PICK))
        setInit作業情報(res.data.作業受注配車工程 ?? createInit作業情報(e工程区分.作業))
        setInit返却情報(res.data.返却受注配車工程 ?? createInit作業情報(e工程区分.返却))
        setInitその他情報(res.data.その他受注配車工程 ?? createInit作業情報(e工程区分.その他))
        // comboboxのループ対応のため初期値用のstateに入れる
        set請求支払情報({
          data: create請求支払CollectionView(res.data),
        })
        // 紐づいたデータに応じて荷主請求と請求内訳を取得し設定する
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: res.data.荷主ID,
          削除済み包含フラグ: true,
        })
        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([..._.orderBy(荷主請求res.data, ["荷主コード", "表紙分割コード"])])

          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([..._.orderBy(請求内訳Res.data, ["請求内訳コード"])])
          } else {
            set請求内訳ItemSource([])
          }
          return res
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
          return res
        }
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  const createコース編集 = () => {
    let コース編集Text = createコース編集Inner({
      PICK情報,
      その他情報,
      作業情報,
      返却情報,
    })

    if (wjCore.isNullOrWhiteSpace(コース編集Text)) return
    setコース編集(コース編集Text)
  }

  const getPatternItemsSource =
    (inner受注部所コード: string) =>
    (query: string, max: number, callback: (items: TKaikonZyutyuHaisyaPatternListGetRes[]) => void) => {
      if (query == null || wjCore.isNullOrWhiteSpace(query)) {
        callback([])
        return
      } else {
        if (inner受注部所コード == null || inner受注部所コード === "") {
          return []
        }
        const service = new KaikonZyutyuHaisyaPatternService()
        return service
          .getList({
            受注配車パターンコード: query,
            受注部所コード: inner受注部所コード,
          })
          .then((res) => {
            const selectItem = res.data
              ? res.data.map((d) => {
                  let displayName = `${d.受注配車パターンコード ?? ""}`
                  let detailText = ``
                  detailText = commonUtil.addTextWithStartDelimiter(detailText, [d.荷主名])
                  if (detailText !== "") {
                    displayName += `: ${detailText}`
                  }
                  return { ...d, displayName }
                })
              : []

            callback(selectItem)
          })
      }
    }

  /**
   * 画面の単項目にデータを設定する
   * @param data
   */
  const setData = (data: TKaikonZyutyuHaisyaGetRes) => {
    set荷主コード(data.荷主コード)
    荷主コードRef.current = data.荷主コード
    set受注パターンコード(data.受注配車パターンコード)
    set荷主略称1(data.荷主略称1)
    set受注部所コード(data.受注部所コード ?? "")
    set荷主請求ID(data.荷主請求ID)
    set荷主依頼番号(data.荷主依頼番号)
    set配車状態区分コード(data.配車状態区分コード)
    setコンテナno(data.コンテナNO ?? "")
    set船社(data.船社 ?? "")
    setBLBK(data.BLBK ?? "")
    set本船名(data.本船名 ?? "")
    setVOY(data.VOY ?? "")
    setコンテナサイズ区分コード(data.コンテナサイズコード)
    setコンテナ軸区分コード(data.コンテナ軸コード)
    setオーダー内容(data.オーダー内容)
    setオーダー備考(data.オーダー備考)
    setオーダー指定時間(data.オーダー指定時間)
    set更新日時(data.更新日時)
    set請求計上日(data.請求計上日)
    set計上基準日区分コード(data.計上基準日区分コード ?? "")
    set計上基準日区分名称(data.計上基準日区分名称1 ?? "")
    set請求内訳id(data.荷主請求内訳ID)
    set請求区分コード(data.請求区分コード)
    set請求額確認区分名称1(data.請求額確認区分名称1)
    set請求額確認区分コード(data.請求額確認区分コード)
    set請求処理状態区分コード(data.請求処理状態区分コード)
    set請求車番(data.請求車番)
    setコース編集(data.コース編集)
    set受領書有無フラグ(data.受領書有無フラグ ?? 0)
    set受領書確認フラグ(data.受領書確認フラグ ?? 0)
    if (data.支払先ID) {
      const 傭車会社 = 支払先ItemSource?.find((d) => d.支払先ID === data.支払先ID)
      set傭車会社コード(傭車会社?.支払先コード)
    }
  }

  const 請求initializedHandler = (grid: wjcGrid.FlexGrid) => {
    grid?.formatItem.addHandler(請求formatItemHandler)
    請求flexGrid?.beginningEdit.addHandler(請求beginningEditHandler)
    set請求支払GridInitialized(true)
    set請求FlexGrid(grid)
  }

  const 請求formatItemHandler = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        if (["付帯料金額", "高速料金額"].includes(e.getColumn().binding ?? "") && e.getRow().dataIndex === 0) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
        if (is請求確認済()) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  const 請求beginningEditHandler = (f: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    if (e.panel === f.cells) {
      if (["付帯料金額", "高速料金額"].includes(e.getColumn().binding ?? "") && e.getRow().dataIndex === 0) {
        e.cancel = true
        return
      }
    }
  }

  // 荷主itemSource取得 TODO:オートコンプリートが作成されたらオートコンプリートにする
  const get荷主itemSource = async () => {
    try {
      const res = await new NinusiService().getList({
        荷主コード: 荷主コード,
      })
      set荷主ItemSource(res.data)
    } catch (error) {
    } finally {
    }
  }
  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    let messages: string[] = []
    let isError = false
    // 必須チェック
    const 必須Valid = 必須validate()
    isError = 必須Valid.hasError === true ? true : isError
    messages.push(...必須Valid.messages)

    if (isError) {
      dispatch(setWarningAlerts(messages))
      return
    }
    setIsConfirmModalShow(true)
  }
  /**
   * エラークリア
   */
  const clearError = () => {
    dispatch(clearAlert())
  }

  /**
   * 必須チェック
   * @param putData: T受注配車入力GridItem[]
   */
  const 必須validate = () => {
    let 必須エラー = false
    let 表紙名エラー = false
    let 荷主コードエラー = false
    let 請求内訳エラー = false
    let 日付エラー = false
    const エラーメッセージList: string[] = []

    const 運行部所未存在エラー =
      (PICK情報?.運行部所コード == null || PICK情報?.運行部所コード === "") &&
      (作業情報?.運行部所コード == null || 作業情報?.運行部所コード === "") &&
      (返却情報?.運行部所コード == null || 返却情報?.運行部所コード === "") &&
      (その他情報?.運行部所コード == null || その他情報?.運行部所コード === "")

    // 作業日が入っているのに運行部所がない場合エラー
    const 組み合わせエラー存在List: string[] = []

    if (PICK情報?.積卸日 && !PICK情報?.運行部所コード) 組み合わせエラー存在List.push("PICK")
    if (作業情報?.積卸日 && !作業情報?.運行部所コード) 組み合わせエラー存在List.push("作業")
    if (返却情報?.積卸日 && !返却情報?.運行部所コード) 組み合わせエラー存在List.push("返却")
    if (その他情報?.積卸日 && !その他情報?.運行部所コード) 組み合わせエラー存在List.push("その他")

    if (受注部所コード == null || 受注部所コード === "") {
      必須エラー = true
      エラーメッセージList.push("受注部所は必須入力です")
    }

    if (荷主コード == null || 荷主コード === "") {
      if (!荷主コードエラー) {
        荷主コードエラー = true
        エラーメッセージList.push("荷主コードは必須入力です")
      }
    }
    if (荷主請求ID == null) {
      if (!表紙名エラー) {
        表紙名エラー = true
        エラーメッセージList.push("表紙名は必須入力です")
      }
    }
    if (請求内訳id == null) {
      if (!請求内訳エラー) {
        請求内訳エラー = true
        エラーメッセージList.push("請求内訳は必須入力です")
      }
    }
    if (!PICK情報?.積卸日 && !作業情報?.積卸日 && !返却情報?.積卸日 && !その他情報?.積卸日) {
      if (!日付エラー) {
        日付エラー = true
        エラーメッセージList.push("PICK,作業,返却,その他のいずれかの日付は必須入力です")
      }
    }
    if (運行部所未存在エラー) {
      必須エラー = true
      エラーメッセージList.push("運行部所は必須入力です")
    }

    if (組み合わせエラー存在List.length > 0) {
      必須エラー = true
      組み合わせエラー存在List.forEach((工程) => {
        エラーメッセージList.push(工程 + "工程作業日が入力されていますが運行部所が選択されていません")
      })
    }
    return {
      hasError: 必須エラー || 表紙名エラー || 荷主コードエラー || 日付エラー,
      messages: エラーメッセージList,
    }
  }

  /**
   * 送信
   */
  const submit = async (isMove: boolean) => {
    try {
      const service = new KaikonZyutyuHaisyaService()
      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, createUpsertData())
        // 更新
      } else {
        // 登録
        res = await service.post(createUpsertData())
      }
      if (res) {
        isPrompt.current = false
        if (isMove) {
          history.goBack()
        } else {
          commonUtil.goToPageTop()
        }
        showInfoToast(`受注配車の${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 送信データ作成
   */
  const createUpsertData = () => {
    // 配車状態区分が空もしくは未配車かつ車輌が登録されていた場合、自動的に配車確定に変更
    let d配車状態区分コード = 配車状態区分コード
    if (
      d配車状態区分コード == null ||
      d配車状態区分コード === "" ||
      d配車状態区分コード === e配車状態区分.海コン未配車
    ) {
      if (
        !(!PICK情報?.積卸日 && PICK情報?.車番) &&
        !(!作業情報?.積卸日 && 作業情報?.車番) &&
        !(!返却情報?.積卸日 && 返却情報?.車番) &&
        !(!その他情報?.積卸日 && その他情報?.車番)
      ) {
        d配車状態区分コード = e配車状態区分.手配済
      }
    }
    const upsertData: TKaikonZyutyuHaisyaGetRes = {
      受注配車ID: id ? parseInt(id) : undefined,
      荷主コード: 荷主コード,
      荷主名: 荷主略称1,
      受注配車パターンコード: 受注パターンコード,
      荷主請求ID: 荷主請求ID ?? undefined,
      表紙名: 荷主請求ID?.toString() ?? undefined,
      配車状態区分コード: d配車状態区分コード ?? undefined,
      荷主依頼番号: 荷主依頼番号,
      受注伝票番号: searchResult?.受注伝票番号 ?? undefined,
      受注枝番: searchResult?.受注枝番 ?? undefined,
      コンテナNO: コンテナNO,
      船社: 船社,
      BLBK: BLBK,
      本船名: 本船名,
      VOY: VOY,
      コンテナサイズコード: コンテナサイズ区分コード ?? "",
      コンテナ軸コード: コンテナ軸区分コード ?? "",
      コース編集: コース編集,
      オーダー内容: オーダー内容,
      オーダー備考: オーダー備考,
      オーダー指定時間: オーダー指定時間,
      受注部所コード: 受注部所コード ?? undefined,
      運行部所コード:
        PICK情報?.運行部所コード ?? 作業情報?.運行部所コード ?? 返却情報?.運行部所コード ?? その他情報?.運行部所コード,
      支払先コード: 傭車会社コード,
      荷主請求内訳ID: 請求内訳id ?? undefined,
      請求区分コード: 請求区分コード ?? undefined,
      請求額確認区分コード,
      請求車番: 請求車番,
      請求運送料課税区分コード: 請求支払情報.data.items[0].運送料課税区分コード,
      請求運送料: 請求支払情報.data.items[0].運送料金額,
      請求付帯料課税区分コード: 請求支払情報.data.items[0].付帯料課税区分コード,
      請求付帯料: 請求支払情報.data.items[0].付帯料金額,
      請求高速料税込区分コード: 請求支払情報.data.items[0].高速料金税込区分コード,
      請求高速料: 請求支払情報.data.items[0].高速料金額,
      計上基準日区分名称1: 計上基準日区分名称 ?? "",
      請求計上日: 請求計上日 ?? "",
      計上基準日区分コード: 計上基準日区分コード ?? "",
      請求備考: 請求支払情報.data.items[0].備考,
      支払運送料: 請求支払情報.data.items[1].運送料金額,
      支払付帯料: 請求支払情報.data.items[1].付帯料金額,
      支払高速料: 請求支払情報.data.items[1].高速料金額,
      支払備考: 請求支払情報.data.items[1].備考,
      更新日時: 更新日時 ?? "",
      受領書有無フラグ: 受領書有無フラグ ?? 0,
      受領書確認フラグ: 受領書確認フラグ ?? 0,
      PICK受注配車工程:
        PICK情報?.受注配車工程ID ||
        PICK情報?.受注配車ID ||
        PICK情報?.積卸日 ||
        PICK情報?.積卸時間 ||
        PICK情報?.積卸先ID ||
        PICK情報?.積卸先コード ||
        PICK情報?.積卸先名 ||
        PICK情報?.積卸先都道府県 ||
        PICK情報?.積卸先市区町村 ||
        PICK情報?.積卸先番地 ||
        PICK情報?.運行部所ID ||
        PICK情報?.運行部所コード ||
        PICK情報?.傭車会社名 ||
        PICK情報?.支払先ID ||
        PICK情報?.車輌ID ||
        PICK情報?.車番 ||
        PICK情報?.車輌分配率 ||
        PICK情報?.トレーラ車輌ID ||
        PICK情報?.トレーラ車番 ||
        PICK情報?.乗務員売上額 ||
        PICK情報?.乗務員ID ||
        PICK情報?.乗務員名 ||
        PICK情報?.乗務員食事手当 ||
        PICK情報?.海コン付帯高速料 ||
        PICK情報?.海コン特別手当 ||
        PICK情報?.同乗者乗務員ID ||
        PICK情報?.同乗者乗務員名 ||
        PICK情報?.海コン作業内容 ||
        PICK情報?.海コン付帯作業区分コード ||
        PICK情報?.海コン付帯作業手当 ||
        PICK情報?.カット日 ||
        PICK情報?.工程備考
          ? PICK情報
          : undefined,
      作業受注配車工程:
        作業情報?.受注配車工程ID ||
        作業情報?.受注配車ID ||
        作業情報?.積卸日 ||
        作業情報?.積卸時間 ||
        作業情報?.積卸先ID ||
        作業情報?.積卸先コード ||
        作業情報?.積卸先名 ||
        作業情報?.積卸先都道府県 ||
        作業情報?.積卸先市区町村 ||
        作業情報?.積卸先番地 ||
        作業情報?.運行部所ID ||
        作業情報?.運行部所コード ||
        作業情報?.傭車会社名 ||
        作業情報?.支払先ID ||
        作業情報?.車輌ID ||
        作業情報?.車番 ||
        作業情報?.車輌分配率 ||
        作業情報?.トレーラ車輌ID ||
        作業情報?.トレーラ車番 ||
        作業情報?.乗務員売上額 ||
        作業情報?.海コン付帯高速料 ||
        作業情報?.海コン特別手当 ||
        作業情報?.乗務員ID ||
        作業情報?.乗務員名 ||
        作業情報?.乗務員食事手当 ||
        作業情報?.同乗者乗務員ID ||
        作業情報?.同乗者乗務員名 ||
        作業情報?.海コン作業内容 ||
        作業情報?.海コン付帯作業区分コード ||
        作業情報?.海コン付帯作業手当 ||
        作業情報?.工程備考
          ? 作業情報
          : undefined,
      返却受注配車工程:
        返却情報?.受注配車工程ID ||
        返却情報?.受注配車ID ||
        返却情報?.積卸日 ||
        返却情報?.積卸時間 ||
        返却情報?.積卸先ID ||
        返却情報?.積卸先コード ||
        返却情報?.積卸先名 ||
        返却情報?.積卸先都道府県 ||
        返却情報?.積卸先市区町村 ||
        返却情報?.積卸先番地 ||
        返却情報?.運行部所ID ||
        返却情報?.運行部所コード ||
        返却情報?.傭車会社名 ||
        返却情報?.支払先ID ||
        返却情報?.車輌ID ||
        返却情報?.車番 ||
        返却情報?.車輌分配率 ||
        返却情報?.トレーラ車輌ID ||
        返却情報?.トレーラ車番 ||
        返却情報?.乗務員売上額 ||
        返却情報?.海コン付帯高速料 ||
        返却情報?.海コン特別手当 ||
        返却情報?.乗務員ID ||
        返却情報?.乗務員名 ||
        返却情報?.乗務員食事手当 ||
        返却情報?.同乗者乗務員ID ||
        返却情報?.同乗者乗務員名 ||
        返却情報?.海コン作業内容 ||
        返却情報?.海コン付帯作業区分ID ||
        返却情報?.海コン付帯作業区分コード ||
        返却情報?.海コン付帯作業区分名称1 ||
        返却情報?.海コン付帯作業手当 ||
        返却情報?.カット日 ||
        返却情報?.工程備考
          ? 返却情報
          : undefined,
      その他受注配車工程:
        その他情報?.受注配車工程ID ||
        その他情報?.受注配車ID ||
        その他情報?.積卸日 ||
        その他情報?.積卸時間 ||
        その他情報?.積卸先ID ||
        その他情報?.積卸先コード ||
        その他情報?.積卸先名 ||
        その他情報?.積卸先都道府県 ||
        その他情報?.積卸先市区町村 ||
        その他情報?.積卸先番地 ||
        その他情報?.運行部所ID ||
        その他情報?.運行部所コード ||
        その他情報?.傭車会社名 ||
        その他情報?.支払先ID ||
        その他情報?.車輌ID ||
        その他情報?.車番 ||
        その他情報?.車輌分配率 ||
        その他情報?.トレーラ車輌ID ||
        その他情報?.トレーラ車番 ||
        その他情報?.乗務員売上額 ||
        その他情報?.海コン付帯高速料 ||
        その他情報?.海コン特別手当 ||
        その他情報?.乗務員ID ||
        その他情報?.乗務員名 ||
        その他情報?.乗務員食事手当 ||
        その他情報?.同乗者乗務員ID ||
        その他情報?.同乗者乗務員名 ||
        その他情報?.海コン作業内容 ||
        その他情報?.海コン付帯作業区分ID ||
        その他情報?.海コン付帯作業区分コード ||
        その他情報?.海コン付帯作業区分名称1 ||
        その他情報?.海コン付帯作業手当 ||
        その他情報?.工程備考
          ? その他情報
          : undefined,
    }
    switch (計上基準日区分コード) {
      case e計上基準日区分.PICK日:
        upsertData.車輌ID = PICK情報?.車輌ID
        upsertData.車番 = PICK情報?.車番
        upsertData.トレーラ車輌ID = PICK情報?.トレーラ車輌ID
        upsertData.トレーラ車番 = PICK情報?.トレーラ車番
        upsertData.乗務員ID = PICK情報?.乗務員ID
        upsertData.乗務員名 = PICK情報?.乗務員名
        upsertData.同乗者乗務員ID = PICK情報?.同乗者乗務員ID
        upsertData.同乗者名 = PICK情報?.同乗者乗務員名
        break
      case e計上基準日区分.作業日:
        upsertData.車輌ID = 作業情報?.車輌ID
        upsertData.車番 = 作業情報?.車番
        upsertData.トレーラ車輌ID = 作業情報?.トレーラ車輌ID
        upsertData.トレーラ車番 = 作業情報?.トレーラ車番
        upsertData.乗務員ID = 作業情報?.乗務員ID
        upsertData.乗務員名 = 作業情報?.乗務員名
        upsertData.同乗者乗務員ID = 作業情報?.同乗者乗務員ID
        upsertData.同乗者名 = 作業情報?.同乗者乗務員名
        break
      case e計上基準日区分.返却日:
        upsertData.車輌ID = 返却情報?.車輌ID
        upsertData.車番 = 返却情報?.車番
        upsertData.トレーラ車輌ID = 返却情報?.トレーラ車輌ID
        upsertData.トレーラ車番 = 返却情報?.トレーラ車番
        upsertData.乗務員ID = 返却情報?.乗務員ID
        upsertData.乗務員名 = 返却情報?.乗務員名
        upsertData.同乗者乗務員ID = 返却情報?.同乗者乗務員ID
        upsertData.同乗者名 = 返却情報?.同乗者乗務員名
        break
    }
    return upsertData
  }

  const パターンデータ反映 = async () => {
    dispatch(clearAlert())
    try {
      const res = await new KaikonZyutyuHaisyaPatternService().getList({
        受注部所コード: 受注部所コード ?? "",
        受注配車パターンコード: 受注パターンコード,
        パターンコード完全一致フラグ: 1,
      })
      if (res.data && res.data.length > 0) {
        await setPatternData(res.data[0])
      } else {
        dispatch(setWarningAlerts(["存在しないパターンコードです。"]))
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  /**
   * パターン設定
   */
  const setPatternData = async (patternData: TKaikonZyutyuHaisyaPatternListGetRes) => {
    await 荷主取得(patternData.荷主コード)

    set受注パターンコード(patternData.受注配車パターンコード)
    set受注部所コード(patternData.受注部所コード ?? "")
    set荷主コード(patternData.荷主コード)
    荷主コードRef.current = patternData.荷主コード
    set荷主略称1(patternData.荷主略称1)

    set荷主請求ID(patternData.荷主請求ID)

    set請求内訳id(patternData.荷主請求内訳ID)

    setコンテナサイズ区分コード(patternData.コンテナサイズコード)
    setコンテナ軸区分コード(patternData.コンテナ軸コード)

    set請求支払情報({
      data: setPattern請求支払CollectionView(patternData),
    })

    let PICKData: TKaikonZyutyuHaisyaKoteiGetRes = PICK情報 ?? {}
    PICKData.工程区分コード = e工程区分.PICK
    PICKData.工程区分名称1 = e工程区分名称[e工程区分.PICK].toString()
    PICKData.積卸先ID = patternData.PICK積卸先ID
    PICKData.積卸先コード = patternData.PICK積卸先コード
    PICKData.積卸先名 = patternData.PICK積卸先名称
    PICKData.積卸先都道府県 = patternData.PICK積卸先都道府県
    PICKData.積卸先市区町村 = patternData.PICK積卸先市区町村
    PICKData.運行部所ID = patternData.PICK運行部所ID
    PICKData.運行部所コード = patternData.PICK運行部所コード
    PICKData.車輌ID = patternData.PICK車輌ID
    PICKData.車番 = patternData.PICK車番
    PICKData.トレーラ車輌ID = patternData.PICKトレーラ車輌ID
    PICKData.トレーラ車番 = patternData.PICKトレーラ車番
    PICKData.乗務員売上額 = patternData.PICK乗務員売上額
    PICKData.乗務員ID = patternData.PICK乗務員ID
    PICKData.乗務員名 = patternData.PICK乗務員名
    PICKData.乗務員食事手当 = patternData.PICK乗務員食事手当

    PICKData.同乗者乗務員ID = patternData.PICK同乗者ID
    PICKData.同乗者乗務員名 = patternData.PICK同乗者名
    PICKData.海コン付帯作業区分ID = patternData.PICK付帯作業区分ID
    PICKData.海コン付帯作業区分コード = patternData.PICK付帯作業区分コード
    PICKData.海コン付帯作業区分名称1 = patternData.PICK付帯作業区分名称1
    PICKData.海コン付帯作業手当 = patternData.PICK付帯作業手当
    PICKData.海コン付帯高速料 = patternData.PICK海コン付帯高速料
    PICKData.工程備考 = patternData.PICK工程備考

    let 作業Data: TKaikonZyutyuHaisyaKoteiGetRes = 作業情報 ?? {}
    作業Data.工程区分コード = e工程区分.作業
    作業Data.工程区分名称1 = e工程区分名称[e工程区分.作業].toString()
    作業Data.積卸先ID = patternData.作業積卸先ID
    作業Data.積卸先コード = patternData.作業積卸先コード
    作業Data.積卸先名 = patternData.作業積卸先名称
    作業Data.積卸先都道府県 = patternData.作業積卸先都道府県
    作業Data.積卸先市区町村 = patternData.作業積卸先市区町村
    作業Data.運行部所ID = patternData.作業運行部所ID
    作業Data.運行部所コード = patternData.作業運行部所コード
    作業Data.車輌ID = patternData.作業車輌ID
    作業Data.車番 = patternData.作業車番
    作業Data.トレーラ車輌ID = patternData.作業トレーラ車輌ID
    作業Data.トレーラ車番 = patternData.作業トレーラ車番
    作業Data.乗務員売上額 = patternData.作業乗務員売上額
    作業Data.乗務員ID = patternData.作業乗務員ID
    作業Data.乗務員名 = patternData.作業乗務員名
    作業Data.乗務員食事手当 = patternData.作業乗務員食事手当
    作業Data.同乗者乗務員ID = patternData.作業同乗者ID
    作業Data.同乗者乗務員名 = patternData.作業同乗者名
    作業Data.海コン作業内容 = patternData.作業内容
    作業Data.海コン付帯作業区分ID = patternData.海コン付帯作業区分ID
    作業Data.海コン付帯作業区分コード = patternData.作業付帯作業区分コード
    作業Data.海コン付帯作業区分名称1 = patternData.付帯作業区分名称1
    作業Data.海コン付帯作業手当 = patternData.作業付帯作業手当
    作業Data.海コン付帯高速料 = patternData.作業海コン付帯高速料
    作業Data.工程備考 = patternData.作業工程備考

    let 返却Data: TKaikonZyutyuHaisyaKoteiGetRes = 返却情報 ?? {}
    返却Data.工程区分コード = e工程区分.返却
    返却Data.工程区分名称1 = e工程区分名称[e工程区分.返却].toString()
    返却Data.積卸先ID = patternData.返却積卸先ID
    返却Data.積卸先コード = patternData.返却積卸先コード
    返却Data.積卸先名 = patternData.返却積卸先名称
    返却Data.積卸先都道府県 = patternData.返却積卸先都道府県
    返却Data.積卸先市区町村 = patternData.返却積卸先市区町村
    返却Data.運行部所ID = patternData.返却運行部所ID
    返却Data.運行部所コード = patternData.返却運行部所コード
    返却Data.車輌ID = patternData.返却車輌ID
    返却Data.車番 = patternData.返却車番
    返却Data.トレーラ車輌ID = patternData.返却トレーラ車輌ID
    返却Data.トレーラ車番 = patternData.返却トレーラ車番
    返却Data.乗務員売上額 = patternData.返却乗務員売上額
    返却Data.乗務員ID = patternData.返却乗務員ID
    返却Data.乗務員名 = patternData.返却乗務員名
    返却Data.乗務員食事手当 = patternData.返却乗務員食事手当
    返却Data.同乗者乗務員ID = patternData.返却同乗者ID
    返却Data.同乗者乗務員名 = patternData.返却同乗者名
    返却Data.海コン付帯作業区分ID = patternData.返却付帯作業区分ID
    返却Data.海コン付帯作業区分コード = patternData.返却付帯作業区分コード
    返却Data.海コン付帯作業区分名称1 = patternData.返却付帯作業区分名称1
    返却Data.海コン付帯作業手当 = patternData.返却付帯作業手当
    返却Data.海コン付帯高速料 = patternData.返却海コン付帯高速料
    返却Data.工程備考 = patternData.返却工程備考

    let その他Data: TKaikonZyutyuHaisyaKoteiGetRes = その他情報 ?? {}
    その他Data.工程区分コード = e工程区分.その他
    その他Data.工程区分名称1 = e工程区分名称[e工程区分.その他].toString()
    その他Data.積卸先ID = patternData.その他積卸先ID
    その他Data.積卸先コード = patternData.その他積卸先コード
    その他Data.積卸先名 = patternData.その他積卸先名称
    その他Data.積卸先都道府県 = patternData.その他積卸先都道府県
    その他Data.積卸先市区町村 = patternData.その他積卸先市区町村
    その他Data.運行部所ID = patternData.その他運行部所ID
    その他Data.運行部所コード = patternData.その他運行部所コード
    その他Data.車輌ID = patternData.その他車輌ID
    その他Data.車番 = patternData.その他車番
    その他Data.トレーラ車輌ID = patternData.その他トレーラ車輌ID
    その他Data.トレーラ車番 = patternData.その他トレーラ車番
    その他Data.乗務員売上額 = patternData.その他乗務員売上額
    その他Data.乗務員ID = patternData.その他乗務員ID
    その他Data.乗務員名 = patternData.その他乗務員名
    その他Data.乗務員食事手当 = patternData.その他乗務員食事手当
    その他Data.同乗者乗務員ID = patternData.その他同乗者ID
    その他Data.同乗者乗務員名 = patternData.その他同乗者名
    その他Data.海コン付帯作業区分ID = patternData.その他付帯作業区分ID
    その他Data.海コン付帯作業区分コード = patternData.その他付帯作業区分コード
    その他Data.海コン付帯作業区分名称1 = patternData.その他付帯作業区分名称1
    その他Data.海コン付帯作業手当 = patternData.その他付帯作業手当
    その他Data.海コン付帯高速料 = patternData.その他海コン付帯高速料
    その他Data.工程備考 = patternData.その他工程備考

    setPICK情報(PICKData)
    set作業情報(作業Data)
    set返却情報(返却Data)
    setその他情報(その他Data)
    setInitPICK情報(PICKData)
    setInit作業情報(作業Data)
    setInit返却情報(返却Data)
    setInitその他情報(その他Data)
  }

  /**
   * 削除モーダル
   */
  const beforeDeleteSubmit = () => {
    setIsConfirmDeleteModalShow(true)
  }

  /**
   * 削除
   */
  const deletePatten = async () => {
    try {
      const service = new KaikonZyutyuHaisyaService()
      let res: TApiResponse<boolean>
      res = await service.delete(id)
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`海コン受注配車の削除が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  /**
   * 請求額確認
   */
  const is請求確認済 = () =>
    is請求確認済Inner({
      請求額確認区分コード,
      請求処理状態区分コード,
    })

  //#endregion
  return (
    <>
      <Form>
        <Container fluid>
          {/* 画面タイトル */}
          <Row className="page-title-row">
            <Col className="page-title-col">
              <span className="page-title">海コン受注配車入力</span>
            </Col>
          </Row>
          {/* アラート表示 */}
          <Row>
            <Col>
              <AlertComponent />
            </Col>
          </Row>
          <Row>
            <Col>
              {/* 海コン受注カード */}
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faFileImport}></FontAwesomeIcon>
                  <span>
                    {id ? `受注No. ${searchResult?.受注伝票番号 ?? ""}-${searchResult?.受注枝番 ?? ""}` : "海コン受注"}
                  </span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">パターンコード</th>
                              <td colSpan={3}>
                                <div className="input-group">
                                  {/* TODO:パターンコードは更新時は更新不可にする */}
                                  {/* TODO:一覧と同時対応が必要なため一旦保留 */}

                                  <div className="w-13rem">
                                    <wjrInput.AutoComplete
                                      headerPath={"受注配車パターンコード"}
                                      showDropDownButton={false}
                                      delay={200}
                                      isEditable={true}
                                      selectedValue={受注パターンコード}
                                      gotFocus={(control: wjcInput.AutoComplete) => {
                                        control.itemsSourceFunction = getPatternItemsSource(
                                          受注部所コードRef.current ?? "",
                                        )
                                      }}
                                      lostFocus={(control: wjcInput.AutoComplete) => {
                                        if (control.selectedItem) {
                                          const 受注パターン: TKaikonZyutyuHaisyaPatternListGetRes =
                                            control.selectedItem
                                          set受注パターンコード(受注パターン.受注配車パターンコード)
                                        } else {
                                          // 1つしかアイテムがない場合、先頭を取得し埋め込む
                                          const itemsSource: wjCore.CollectionView = control.itemsSource
                                          const sourceCollection: TKaikonZyutyuHaisyaPatternListGetRes[] =
                                            itemsSource?.sourceCollection ?? []
                                          if (sourceCollection.length === 1) {
                                            const 受注パターン: TKaikonZyutyuHaisyaPatternListGetRes =
                                              sourceCollection[0]
                                            control.selectedItem = 受注パターン
                                            set受注パターンコード(受注パターン.受注配車パターンコード)
                                          } else {
                                            set受注パターンコード(control.text ?? "")
                                          }
                                        }
                                      }}
                                      displayMemberPath="displayName"
                                      selectedValuePath="受注配車パターンコード"></wjrInput.AutoComplete>
                                  </div>

                                  <button
                                    type="button"
                                    className="icon-button"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      setモーダル検索用荷主コード(荷主コード)
                                      setモーダル検索用荷主名(荷主略称1)
                                      setIs海コン受注配車パターン検索Modal(true)
                                    }}
                                    disabled={is請求確認済()}>
                                    <FontAwesomeIcon className="icon-button-inner" icon={faSearch}></FontAwesomeIcon>
                                  </button>
                                  <Button
                                    className="btn btn-small"
                                    style={{
                                      margin: "auto",
                                      marginLeft: ".3rem",
                                      borderTopLeftRadius: "0.25rem",
                                      borderBottomLeftRadius: "0.25rem",
                                    }}
                                    disabled={
                                      is請求確認済() ||
                                      受注パターンコード == null ||
                                      受注パターンコード === "" ||
                                      受注部所コード == null ||
                                      受注部所コード === ""
                                    }
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()

                                      パターンデータ反映()
                                    }}>
                                    反映
                                  </Button>
                                </div>
                              </td>
                              <th className="min-w-8rem">
                                受注部所
                                <RequiredMark />
                              </th>
                              <td>
                                <ComboBox.Busyo
                                  isLoadEnded={受注部所isLoadEnded}
                                  setIsLoadEnded={set受注部所isLoadEnded}
                                  defaultValue={受注部所コード ?? userInfo.部所コード}
                                  isDisabled={is請求確認済()}
                                  isEmpty={true}
                                  isRequired={true}
                                  listFilter={(d) => d.運行部所フラグ === 1}
                                  itemsSource={部所ItemSource}
                                  selectedItem={select受注部所}
                                  setSelectedItem={(v) => {
                                    setSelect受注部所(v ?? undefined)
                                  }}
                                  selectedValue={受注部所コード}
                                  setSelectedValue={(v) => {
                                    set受注部所コード(v)
                                    受注部所コードRef.current = v ?? undefined
                                  }}
                                  ComboBox={受注部所ComboBox}
                                  setComboBox={set受注部所ComboBox}></ComboBox.Busyo>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">
                                荷主
                                <RequiredMark />
                              </th>
                              <td colSpan={3}>
                                <div className="input-group">
                                  <TextInput
                                    style={{ width: "6rem" }}
                                    id="荷主コード"
                                    name="荷主コード"
                                    value={荷主コード}
                                    setValue={async (v) => {
                                      荷主コードRef.current = v
                                      set荷主コード(v)
                                    }}
                                    onBlur={() => {
                                      荷主取得(荷主コードRef.current)
                                    }}
                                    maxLength={5}
                                    isReadOnly={is請求確認済()}
                                  />
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault()
                                      setIs荷主検索Modal(true)
                                    }}
                                    type="button"
                                    className="icon-button"
                                    disabled={is請求確認済()}>
                                    <FontAwesomeIcon className="icon-button-inner" icon={faSearch}></FontAwesomeIcon>
                                  </button>
                                  <TextInput
                                    style={{ width: "30rem" }}
                                    isReadOnly={true}
                                    id="荷主名"
                                    name="荷主名"
                                    value={荷主略称1}
                                    setValue={set荷主略称1}
                                    maxLength={100}
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">請求額確認</th>
                              <td>
                                <TextInput
                                  id="請求額確認区分名称1"
                                  name="請求額確認区分名称1"
                                  value={請求額確認区分名称1}
                                  isReadOnly={true}
                                  setValue={set請求額確認区分名称1}
                                  maxLength={50}
                                />
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">
                                表紙名
                                <RequiredMark />
                              </th>
                              <td className="w-14rem">
                                <ComboBox.HyosiBunkatu
                                  itemsSource={荷主請求ItemSource}
                                  isLoadEnded={表紙分割IsLoadEnded}
                                  setIsLoadEnded={set表紙分割IsLoadEnded}
                                  isEmpty={true}
                                  setSelectedValue={(v) => {
                                    if (v === 0) {
                                      set荷主請求ID(undefined)
                                    } else {
                                      set荷主請求ID(v)
                                      荷主請求Ref.current = v
                                    }
                                  }}
                                  selectedValue={荷主請求ID}
                                  ComboBox={表紙分割ComboBox}
                                  setComboBox={set表紙分割ComboBox}
                                  isDisabled={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">荷主依頼No</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="荷主依頼No"
                                  name="荷主依頼No"
                                  value={荷主依頼番号}
                                  setValue={set荷主依頼番号}
                                  maxLength={100}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">作業状態</th>
                              <td className="w-14rem">
                                <ComboBox.Kubun
                                  分類コード={区分分類コード.受注配車_請求支払.配車状態区分}
                                  isRequired={false}
                                  itemsSource={作業区分ItemSource}
                                  isLoadEnded={配車状態区分isLoadEnded}
                                  setIsLoadEnded={set配車状態区分isLoadEnded}
                                  selectedValue={配車状態区分コード}
                                  setSelectedValue={(v) => {
                                    set配車状態区分コード(v)
                                  }}
                                  ComboBox={配車状態区分ComboBox}
                                  setComboBox={set配車状態区分ComboBox}
                                  isDisabled={is請求確認済()}
                                />
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">内容</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="内容"
                                  name="内容"
                                  value={オーダー内容}
                                  setValue={(v) => {
                                    setオーダー内容(v)
                                  }}
                                  maxLength={200}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">備考</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="備考"
                                  name="備考"
                                  value={オーダー備考}
                                  setValue={(v) => {
                                    setオーダー備考(v)
                                  }}
                                  maxLength={200}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">指定時間</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="指定時間"
                                  name="指定時間"
                                  value={オーダー指定時間}
                                  setValue={(v) => {
                                    setオーダー指定時間(v)
                                  }}
                                  maxLength={200}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">コンテナNO.</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="コンテナNO"
                                  name="コンテナNO"
                                  value={コンテナNO}
                                  setValue={(v) => {
                                    setコンテナno(v)
                                  }}
                                  maxLength={11}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">コンテナサイズ</th>
                              <td className="w-14rem">
                                <ComboBox.Kubun
                                  分類コード={区分分類コード.受注配車_請求支払.コンテナサイズ}
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={コンテナサイズIsLoadEnded}
                                  setIsLoadEnded={setコンテナサイズIsLoadEnded}
                                  setSelectedValue={(v) => {
                                    setコンテナサイズ区分コード(v)
                                  }}
                                  selectedValue={コンテナサイズ区分コード}
                                  ComboBox={コンテナサイズComboBox}
                                  setComboBox={setコンテナサイズComboBox}
                                  isDisabled={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">コンテナ軸</th>
                              <td className="w-14rem">
                                <ComboBox.Kubun
                                  分類コード={区分分類コード.受注配車_請求支払.コンテナ軸}
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={コンテナ軸IsLoadEnded}
                                  setIsLoadEnded={setコンテナ軸IsLoadEnded}
                                  setSelectedValue={(v) => {
                                    setコンテナ軸区分コード(v)
                                  }}
                                  selectedValue={コンテナ軸区分コード}
                                  ComboBox={コンテナ軸ComboBox}
                                  setComboBox={setコンテナ軸ComboBox}
                                  isDisabled={is請求確認済()}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">船社</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="船社"
                                  name="船社"
                                  value={船社}
                                  setValue={(v) => {
                                    set船社(v)
                                  }}
                                  maxLength={100}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">B/L・B/K</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="BLBK"
                                  name="BLBK"
                                  value={BLBK}
                                  setValue={(v) => {
                                    setBLBK(v)
                                  }}
                                  maxLength={100}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">本船名</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="本船名"
                                  name="本船名"
                                  value={本船名}
                                  setValue={(v) => {
                                    set本船名(v)
                                  }}
                                  maxLength={100}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                              <th className="min-w-8rem">VOY</th>
                              <td className="w-14rem">
                                <TextInput
                                  id="VOY"
                                  name="VOY"
                                  value={VOY}
                                  setValue={(v) => {
                                    setVOY(v)
                                  }}
                                  maxLength={100}
                                  isReadOnly={is請求確認済()}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">請求区分</th>
                              <td className="w-14rem">
                                <ComboBox.Kubun
                                  分類コード={区分分類コード.受注配車_請求支払.請求区分}
                                  isRequired={true}
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={請求区分isLoadEnded}
                                  listFilter={(item) => {
                                    const targetCoeds: string[] = [e請求支払区分.車建て, e請求支払区分.請求支払なし]

                                    return targetCoeds.includes(item.区分コード)
                                  }}
                                  isDisabled={is請求確認済()}
                                  setIsLoadEnded={set請求区分isLoadEnded}
                                  selectedValue={請求区分コード}
                                  setSelectedValue={(v) => {
                                    set請求区分コード(v)
                                  }}
                                  ComboBox={請求区分ComboBox}
                                  setComboBox={set請求区分ComboBox}></ComboBox.Kubun>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faTruck}></FontAwesomeIcon>
                  <span>海コン作業工程配車</span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        <Table className="transpose-table">
                          <thead>
                            <tr className="w-8rem">
                              <th className="row-header">作業工程</th>
                              <th className="row-header">作業日</th>
                              <th className="row-header">フリータイム・カット</th>
                              <th className="row-header">時間</th>
                              <th className="row-header">積卸先コード</th>
                              <th className="row-header">社名（ヤード）</th>
                              <th className="row-header">都道府県</th>
                              <th className="row-header">市区町村</th>
                              <th className="row-header">作業内容</th>
                              <th className="row-header">運行部所</th>
                              <th className="row-header">傭車会社</th>
                              <th className="row-header">車番</th>
                              <th className="row-header">トレーラ車番</th>
                              <th className="row-header">乗務員</th>
                              <th className="row-header">乗務員売上額</th>
                              <th className="row-header">付帯高速料</th>
                              <th className="row-header">ETC情報</th>
                              <th className="row-header">食事代</th>
                              <th className="row-header">同乗者</th>
                              <th className="row-header">付帯作業分類</th>
                              <th className="row-header">付帯作業手当・特別手当</th>
                              <th className="row-header">工程備考</th>
                              <th className="row-header">作業工程</th>
                            </tr>
                          </thead>
                          <tbody>
                            <EtcDataContext.Provider value={ETC情報}>
                              <SagyoGridRow
                                isRestoreSearching={isRestoreSearching}
                                initState={initPICK情報}
                                setState={setPICK情報}
                                ninusiCode={荷主コード}
                                支払先ItemSource={支払先ItemSource}
                                処理伝播用傭車フラグ={PICK情報?.傭車フラグ}
                                傭車会社コード={傭車会社コード}
                                set傭車会社コード={set傭車会社コード}
                                請求額確認区分コード={請求額確認区分コード}
                                請求処理状態区分コード={請求処理状態区分コード}></SagyoGridRow>
                              <SagyoGridRow
                                isRestoreSearching={isRestoreSearching}
                                initState={init作業情報}
                                setState={set作業情報}
                                ninusiCode={荷主コード}
                                支払先ItemSource={支払先ItemSource}
                                処理伝播用傭車フラグ={PICK情報?.傭車フラグ}
                                傭車会社コード={傭車会社コード}
                                set傭車会社コード={set傭車会社コード}
                                請求額確認区分コード={請求額確認区分コード}
                                請求処理状態区分コード={請求処理状態区分コード}></SagyoGridRow>
                              <SagyoGridRow
                                isRestoreSearching={isRestoreSearching}
                                initState={init返却情報}
                                setState={set返却情報}
                                ninusiCode={荷主コード}
                                支払先ItemSource={支払先ItemSource}
                                処理伝播用傭車フラグ={PICK情報?.傭車フラグ}
                                傭車会社コード={傭車会社コード}
                                set傭車会社コード={set傭車会社コード}
                                請求額確認区分コード={請求額確認区分コード}
                                請求処理状態区分コード={請求処理状態区分コード}></SagyoGridRow>
                              <SagyoGridRow
                                isRestoreSearching={isRestoreSearching}
                                initState={initその他情報}
                                setState={setその他情報}
                                ninusiCode={荷主コード}
                                支払先ItemSource={支払先ItemSource}
                                処理伝播用傭車フラグ={PICK情報?.傭車フラグ}
                                傭車会社コード={傭車会社コード}
                                set傭車会社コード={set傭車会社コード}
                                請求額確認区分コード={請求額確認区分コード}
                                請求処理状態区分コード={請求処理状態区分コード}></SagyoGridRow>
                            </EtcDataContext.Provider>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <span>
                    <FontAwesomeIcon icon={faFileInvoiceDollar}></FontAwesomeIcon>
                    受領書情報
                  </span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">受領書有無</th>
                              <td>
                                <div className="w-8rem">
                                  <ComboBox.Default
                                    className="max-w-10rem"
                                    itemsSource={boolList}
                                    selectedValue={受領書有無フラグ}
                                    setSelectedValue={set受領書有無フラグ}
                                    isLoadEnded={受領書有無IsLoadEnded}
                                    setIsLoadEnded={set受領書有無IsLoadEnded}
                                    ComboBox={受領書有無ComboBox}
                                    setComboBox={set受領書有無ComboBox}></ComboBox.Default>
                                </div>
                              </td>
                              <th className="min-w-8rem"> 受領書確認</th>
                              <td className="w-4 rem">
                                <CheckInput
                                  label=""
                                  value={受領書確認フラグ}
                                  setValue={(v) => set受領書確認フラグ(v)}
                                  type={"checkbox"}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <span>
                    <FontAwesomeIcon icon={faFileInvoiceDollar}></FontAwesomeIcon>
                    海コン請求支払情報
                  </span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        <div>
                          <Table className="form-table">
                            <tbody>
                              <tr>
                                <th className="min-w-8rem">請求内訳</th>
                                <td className="w-8rem">
                                  <div className="w-20rem">
                                    <ComboBox.SeikyuUtiwake
                                      isReadOnly={
                                        (請求内訳ItemSource == null || 請求内訳ItemSource.length <= 0 ? true : false) ||
                                        is請求確認済()
                                      }
                                      itemsSource={請求内訳ItemSource}
                                      isLoadEnded={請求内訳IsLoadEnded}
                                      setIsLoadEnded={set請求内訳IsLoadEnded}
                                      setSelectedValue={(v) => {
                                        set請求内訳id(v)
                                      }}
                                      isEmpty={true}
                                      selectedValue={請求内訳id}
                                      ComboBox={請求内訳ComboBox}
                                      setComboBox={set請求内訳ComboBox}
                                    />
                                  </div>
                                </td>
                                <th className="min-w-8rem">請求基準日</th>
                                <td>
                                  <TextInput
                                    id="計上基準日区分"
                                    name="計上基準日区分"
                                    isReadOnly
                                    value={計上基準日区分名称}
                                    setValue={(v) => {
                                      set計上基準日区分名称(v)
                                    }}
                                  />
                                </td>
                                <th className="min-w-8rem">請求計上日</th>
                                <td>
                                  <div className="w-10rem">
                                    <DateInput
                                      id="請求計上日"
                                      isRequired={false}
                                      value={請求計上日}
                                      setValue={(v) => {
                                        set請求計上日(v)
                                      }}
                                      isReadOnly={is請求確認済()}
                                    />
                                  </div>
                                </td>
                                <th className="min-w-8rem">請求車番</th>
                                <td>
                                  <div className="w-10rem">
                                    <TextInput
                                      style={{ width: "8rem" }}
                                      id="請求車番"
                                      name="請求車番"
                                      value={請求車番}
                                      setValue={(v) => {
                                        set請求車番(v)
                                      }}
                                      maxLength={4}
                                      placeholder="請求車番"
                                      isReadOnly={is請求確認済()}
                                    />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <div>
                          <Button
                            className="mx-2"
                            type="button"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            受注請求履歴
                          </Button>
                          <Button
                            className="mx-2"
                            type="button"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            運賃タリフ参照
                          </Button>
                        </div>
                        <wjrGrid.FlexGrid
                          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                          itemsSource={請求支払情報.data}
                          initialized={請求initializedHandler}
                          allowSorting={false}
                          allowDragging={wjcGrid.AllowDragging.None}
                          isReadOnly={false}>
                          <wjrGrid.FlexGridColumn
                            binding="種別"
                            cssClassAll={"read-only-cell"}
                            isReadOnly={true}
                            header="請求支払"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料課税区分コード"
                            width={80}
                            dataMap={課税区分DataMap}
                            isReadOnly={is請求確認済()}
                            header="非/課"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料金額"
                            header="運送料"
                            isReadOnly={is請求確認済()}></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料課税区分コード"
                            width={80}
                            dataMap={課税区分DataMap}
                            header="非/課"
                            isReadOnly={is請求確認済()}></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料金額"
                            header="付帯料"
                            isReadOnly={is請求確認済()}></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料金税込区分コード"
                            width={70}
                            dataMap={税込区分DataMap}
                            cssClassAll={"read-only-cell"}
                            header="税表示"
                            isReadOnly={true}></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料金額"
                            header="高速料（税込）"
                            isReadOnly={is請求確認済()}></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="備考"
                            width={500}
                            align={"left"}
                            header="請求支払備考（付帯作業内容でも使用）"
                            isReadOnly={is請求確認済()}></wjrGrid.FlexGridColumn>
                        </wjrGrid.FlexGrid>
                        {/* </div> */}
                      </Col>
                    </Row>
                  </Container>
                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table d-inline-block">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">コース編集</th>
                              <td>
                                <TextInput
                                  style={{ width: "50rem" }}
                                  id="コース編集"
                                  name="コース編集"
                                  value={コース編集}
                                  setValue={(v) => {
                                    setコース編集(v)
                                  }}
                                  isReadOnly={is請求確認済()}
                                  placeholder="コース編集"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <div className="d-inline-block ms-2 fw-bold text-danger">
                          <div>手入力する際は、海コン受注配車一覧で登録処理をしないように注意してください。</div>
                          <div>※積卸情報で上書きされます。</div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {id == null && (
                          <Button
                            variant="waiting"
                            className="me-4"
                            onClick={(e) => {
                              beforeSubmit()
                              setIsPageMove(false)
                            }}>
                            続けて登録
                          </Button>
                        )}
                        <Button
                          variant="waiting"
                          onClick={(e) => {
                            beforeSubmit()
                            setIsPageMove(true)
                          }}>
                          {id ? "更新" : "登録して戻る"}
                        </Button>
                        <Button
                          size="lg"
                          className="ms-4"
                          variant="caution"
                          onClick={(e) => {
                            beforeDeleteSubmit()
                          }}>
                          削除
                        </Button>
                        <Button type="button" variant="secondary" className="ms-4" onClick={() => history.goBack()}>
                          一覧に戻る
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Form>
      {/* 海コン受注配車パターン検索 */}
      <KaikonZyutyuHaisyaPatternModal
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        zyutyubusyo={select受注部所}
        isShow={is海コン受注配車パターン検索Modal}
        setIsShow={setIs海コン受注配車パターン検索Modal}
        setPattern={(海コン受注配車パターン) => {
          setPatternData(海コン受注配車パターン)
        }}></KaikonZyutyuHaisyaPatternModal>
      {/* 荷主検索 */}
      <NinusiSeikyuSearchModal
        isShow={is荷主検索Modal}
        setIsShow={setIs荷主検索Modal}
        setNinusi={(荷主) => {
          荷主コードRef.current = 荷主.荷主コード
          荷主請求Ref.current = 荷主.荷主請求ID
          set荷主コード(荷主.荷主コード)
          set荷主略称1(荷主.荷主名)
          荷主取得(荷主.荷主コード)
        }}></NinusiSeikyuSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={() => {
          submit(isPageMove)
        }}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={deletePatten}>
        表示の受注配車情報を削除しますか？
      </ConfirmModal>
    </>
  )
}

// defaultComboBox用
const boolList = [
  {
    name: "無",
    value: 0,
  },
  {
    name: "有",
    value: 1,
  },
]

export default KaikonZyutyuHaisyaRegister
